import { useQuery } from "@tanstack/react-query";
import { getTeacherLanguages } from "../../../api/endpoints/LearningPathEndpoints";

export default function useGetTeacherLanguages() {
  return useQuery({
    queryKey: ["teacher-languages"],
    queryFn: getTeacherLanguages,
  });
}
